import React, { ReactNode, FunctionComponent } from 'react';

export type CtaBoxTextProps = {
    children: ReactNode;
    qaRole?: string;
};

const CtaBoxText: FunctionComponent<CtaBoxTextProps> = ({ children, qaRole }) => {
    // todo: check the children validation
    if (!children) {
        return null;
    }

    return (
        <div className="cta-box__text" data-qa-role={qaRole || 'cta-box-text'}>
            {children}
        </div>
    );
};

export default CtaBoxText;
